const hamburger = document.querySelector('.site-header__hamburger');
const drawer = document.getElementById('NavDrawer');
const closeBtn = drawer ? drawer.querySelector('.nav-drawer__close') : null;

if (hamburger && drawer) {
  hamburger.addEventListener('click', () => {
    drawer.showModal();
    hamburger.setAttribute('aria-expanded', 'true');
    closeBtn?.focus();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => drawer.close());
  }

  drawer.addEventListener('close', () => {
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.focus();
  });

  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) drawer.close();
  });

  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    const focusable = Array.from(
      drawer.querySelectorAll(
        'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.hasAttribute('disabled'));

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
}

  /* -------------------------------------------------------------
     Mobile navigation — submenu toggles
     ------------------------------------------------------------- */
  const submenuToggles = drawer.querySelectorAll('.nav-drawer__toggle');

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.nav-drawer__item');
      if (!item) return;

      const isOpen = item.classList.toggle('is-open');

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      const icon = toggle.querySelector('span');
      if (icon) {
        icon.textContent = isOpen ? '−' : '+';
      }
    });
  });

const header = document.querySelector('.site-header');

if (header && header.dataset.sticky === 'true') {
  const sentinel = document.createElement('div');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:1px;pointer-events:none;';
  header.prepend(sentinel);

  const io = new IntersectionObserver(([entry]) => {
    header.classList.toggle('is-sticky', !entry.isIntersecting);
  });

  io.observe(sentinel);
}

document.addEventListener('cart:updated', () => {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cartData) => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cartData.item_count;
        el.classList.toggle('is-empty', cartData.item_count === 0);
      });
    });
});

/* ---------------------------------------------------------------
   Search overlay — click-triggered panel below the header
   --------------------------------------------------------------- */
(() => {
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  const openButtons = document.querySelectorAll('[data-search-overlay-open]');
  const closeButtons = overlay.querySelectorAll('[data-search-overlay-close]');
  const input = overlay.querySelector('[data-search-overlay-input]');

  let lastFocused = null;

  const setExpanded = (expanded) => {
    openButtons.forEach((btn) => {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const openOverlay = (trigger) => {
    if (!overlay.hidden) return;
    lastFocused = trigger || document.activeElement;
    overlay.hidden = false;
    // Force reflow so the CSS transition runs from the [hidden] off-state.
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    setExpanded(true);
    document.body.classList.add('search-overlay-locked');
    // Move focus into the input so a screen reader announces the dialog.
    requestAnimationFrame(() => input?.focus());
  };

  const closeOverlay = () => {
    if (overlay.hidden) return;
    overlay.classList.remove('is-open');
    setExpanded(false);
    document.body.classList.remove('search-overlay-locked');

    // Defer `hidden = true` until the CSS opacity/transform transition finishes
    // so the exit animation isn't short-circuited by `[hidden] { display: none }`.
    const onTransitionEnd = (event) => {
      if (event.target !== overlay) return;
      overlay.hidden = true;
      overlay.removeEventListener('transitionend', onTransitionEnd);
    };
    overlay.addEventListener('transitionend', onTransitionEnd);
    // Fallback if transitionend doesn't fire (interrupted, reduced-motion, etc).
    setTimeout(() => {
      if (!overlay.classList.contains('is-open')) {
        overlay.hidden = true;
        overlay.removeEventListener('transitionend', onTransitionEnd);
      }
    }, 300);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  };

  openButtons.forEach((btn) => {
    btn.addEventListener('click', () => openOverlay(btn));
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closeOverlay);
  });

  // Click outside the panel closes
  overlay.addEventListener('mousedown', (e) => {
    if (e.target === overlay) closeOverlay();
  });

  // Esc closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hidden) {
      e.preventDefault();
      closeOverlay();
    }
  });

  // Focus trap inside the panel
  overlay.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    const focusable = Array.from(
      overlay.querySelectorAll(
        'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.hasAttribute('hidden') && el.offsetParent !== null && el.tabIndex !== -1);

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

})();
